/* eslint-disable import/prefer-default-export */
import { createAction } from 'redux-actions';
import { SEARCH_USERS } from './actionTypes';

export const searchUsers = createAction(SEARCH_USERS);
